<template>
	<div class="ticket">
		<div v-if="objectTicket.id > 0">
			<div class="row">
				<div class="col-md-3">

					<!-- Profile Image -->
					<div class="card card-primary card-outline">
						<div class="card-body box-profile">
							<div class="text-center">
								<img class="profile-user-img img-fluid img-circle"
								:src="'/img/perfil/' + objectTicket.img"
								alt="User profile picture">
							</div>

							<h3 class="profile-username text-center">{{ objectTicket.user }}</h3>

							<p class="text-muted text-center">Creador</p>

							<ul class="list-group list-group-unbordered mb-3">
								<li class="list-group-item">
									<b>Fecha</b> <a class="float-right">{{ objectTicket.created_at }}</a>
								</li>
								<li class="list-group-item">
									<b>Destinatario</b> <a class="float-right">{{ objectTicket.receiver }}</a>
								</li>
								<li class="list-group-item">
									<b>Estado</b> <a class="float-right"><span class="badge badge-primary float-center">{{ objectTicket.status }}</span></a>
								</li>
							</ul>
							
						</div>
						<!-- /.card-body -->
					</div>
					<!-- /.card -->

				</div>
				<!-- /.col -->
				<div class="col-md-9">
					<div class="card">
						<div class="card-header p-2">
							<ul class="nav nav-pills">
								<li class="nav-item"><a class="nav-link active" href="#message" data-toggle="tab">Comentarios</a></li>
								<li class="nav-item"><a class="nav-link" href="#tracking" data-toggle="tab">Seguimiento</a></li>
							</ul>
						</div><!-- /.card-header -->
						<div class="card-body">
							<div class="tab-content">
								<div class="active tab-pane" id="message">
									<!-- comentario -->
									<div style="height: 400px; max-height: 75%; overflow-y: scroll;" ref="divMessages">
										<div class="post" v-for="item in lisTicketMessages">
											<div class="user-block">
												<img class="img-circle img-bordered-sm" :src="'/img/perfil/' + item.img" alt="user image">
												<span class="username">
													<a href="#">{{ item.user }}</a>
												</span>
												<span class="float-right btn-tool pointer" v-if="item.user_id == auth.id">
													<i class="fas fa-times" @click="removeListTicketMessages(item)"></i>
												</span>
												<span class="description">{{ item.created_at }}</span>
											</div>
											<!-- /.user-block -->
											<p :ref="'messaje' + item.id">{{ item.message }} <span class="float-right">i</span></p>
										</div>
									</div>
									<hr>
									<input class="form-control form-control-sm" type="text" placeholder="Escribe tu comentario" v-model="message" @keyup.enter="saveTicketMessage(0, objectTicket.id, message)">
									<!-- /.comentario -->
								</div>
								<!-- /.tab-pane -->
								<div class="tab-pane" id="tracking">
									<!-- The timeline -->
									<div class="timeline timeline-inverse">
										<!-- timeline time label -->
										<div class="time-label">
											<span class="bg-danger">
												10 Feb. 2014
											</span>
										</div>
										<!-- /.timeline-label -->
										<!-- timeline item -->
										<div>
											<i class="fas fa-envelope bg-primary"></i>

											<div class="timeline-item">
												<span class="time"><i class="far fa-clock"></i> 12:05</span>

												<h3 class="timeline-header"><a href="#">Support Team</a> sent you an email</h3>

												<div class="timeline-body">
													Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles,
													weebly ning heekya handango imeem plugg dopplr jibjab, movity
													jajah plickers sifteo edmodo ifttt zimbra. Babblely odeo kaboodle
													quora plaxo ideeli hulu weebly balihoo...
												</div>
												<div class="timeline-footer">
													<a href="#" class="btn btn-primary btn-sm">Read more</a>
													<a href="#" class="btn btn-danger btn-sm">Delete</a>
												</div>
											</div>
										</div>
										<!-- END timeline item -->
										<!-- timeline item -->
										<div>
											<i class="fas fa-user bg-info"></i>

											<div class="timeline-item">
												<span class="time"><i class="far fa-clock"></i> 5 mins ago</span>

												<h3 class="timeline-header border-0"><a href="#">Sarah Young</a> accepted your friend request
												</h3>
											</div>
										</div>
										<!-- END timeline item -->
										<!-- timeline item -->
										<div>
											<i class="fas fa-comments bg-warning"></i>

											<div class="timeline-item">
												<span class="time"><i class="far fa-clock"></i> 27 mins ago</span>

												<h3 class="timeline-header"><a href="#">Jay White</a> commented on your post</h3>

												<div class="timeline-body">
													Take me to your leader!
													Switzerland is small and neutral!
													We are more like Germany, ambitious and misunderstood!
												</div>
												<div class="timeline-footer">
													<a href="#" class="btn btn-warning btn-flat btn-sm">View comment</a>
												</div>
											</div>
										</div>
										<!-- END timeline item -->
										<!-- timeline time label -->
										<div class="time-label">
											<span class="bg-success">
												3 Jan. 2014
											</span>
										</div>
										<!-- /.timeline-label -->
										<!-- timeline item -->
										<div>
											<i class="fas fa-camera bg-purple"></i>

											<div class="timeline-item">
												<span class="time"><i class="far fa-clock"></i> 2 days ago</span>

												<h3 class="timeline-header"><a href="#">Mina Lee</a> uploaded new photos</h3>

												<div class="timeline-body">
													<img src="http://placehold.it/150x100" alt="...">
													<img src="http://placehold.it/150x100" alt="...">
													<img src="http://placehold.it/150x100" alt="...">
													<img src="http://placehold.it/150x100" alt="...">
												</div>
											</div>
										</div>
										<!-- END timeline item -->
										<div>
											<i class="far fa-clock bg-gray"></i>
										</div>
									</div>
								</div>
								<!-- /.tab-pane -->
							</div>
							<!-- /.tab-content -->
						</div><!-- /.card-body -->
					</div>
					<!-- /.nav-tabs-custom -->
				</div>
				<!-- /.col -->
			</div>
		</div>
		<div class="alert alert-danger" role="alert" v-else>
			No existe el ticket {{ idTicket }}
		</div>		
    </div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import ticket from '@/mixins/tickets'
import ticketMessages from '@/mixins/tickets/ticketMessages.js'

export default {
	name: 'Ticket',
    mixins: [axiosAction, errors, mixin, ticket, ticketMessages],
    props: ['idTicket'],
	data() {
		return {
		}
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
            this.showTicket(this.idTicket)
		},
		removeListTicketMessages(item) {
			if(confirm('Esta seguro que quiere borrar el mensaje "' + item.message + '"\n¿Quiere continuar? ')) {
				this.deleteTicketMessage(item.id)
			}
		},
        resultShowTicketGETLocal(response) {
            if(this.objectTicket.id > 0) {
	            this.setListeningTickets()
	            this.setListeningTicketMessages()
				this.setTitleModule(this.objectTicket.subject)
				this.setSubTitleModule(' - Ticket ' + this.idTicket)
				this.getAllTicketMessages(this.objectTicket.id)
            }
		},
	},
	components: {
	},
	mounted () {
		this.initModule()
	}
}
</script>

